import React from 'react';
import {LogoBig} from "../../icons/icons";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const Footer = () => {
  const {t} = useTranslation()
  return (
    <>
      <div className={" backdrop-blur-sm bg-primary-300/5 "}>
        <div className={"p-10 my-container-small "}>
          <div className={'grid grid-cols-1 md:grid-cols-4 gap-10'}>
            <div className={"grid-cols-1"}>
              <LogoBig/>
              <p className={"text-sm text-gray-800 leading-6 py-6"}>
                {t("footerDes")}
              </p>
            </div>
            <div className={"grid  grid-cols-1"}>
              <div className={"text-gray-800 leading-6 pb-6"}>
                {t("SPFLY")}
              </div>
              <div  className={"grid gap-y-4 grid-cols-1"}>
                <Link className={"text-gray-800 leading-6"}>
                  {t("news")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("creator")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("low")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("note")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("aboutOurGroup")}
                </Link>
              </div>
            </div>
            <div className={"grid  grid-cols-1"}>
              <div className={"text-gray-800 leading-6 pb-6 md:pb-0"}>
                {t("linkFooter0")}
              </div>
              <div  className={"grid grid-cols-1 gap-y-4 md:gap-y-0 md:grid-cols-2 md:-mt-16"}>
                <div className={"text-gray-800 leading-6 "}>
                  {t("linkFooter1")}
                </div>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter2")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter3")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter4")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter5")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter6")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter7")}
                </Link>
              </div>
            </div>
            <div className={"grid  grid-cols-1"}>
              <div className={"text-gray-800 leading-6 pb-6"}>
                {t("linkFooter8")}
              </div>
              <div  className={"grid gap-4 grid-cols-1"}>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter9")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter10")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter11")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter12")}
                </Link>
                <Link className={"text-gray-800 leading-6"}>
                  {t("linkFooter13")}
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className={"bg-white p-8 text-center text-main"}>
        {t("lowFooter")}
      </div>
    </>
  );
};

export default Footer;
